import { Link } from "react-router-dom";
import { useEffect } from "react";
import { testimonials } from "@/mocks/articles";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import useJsonLd from "@/hooks/useJsonLd";

export default function About() {
  // Dynamic document title
  useEffect(() => {
    document.title = "关于我们 - 51黑料网 | 最有态度的娱乐爆料平台";
  }, []);

  // Schema.org AboutPage
  useJsonLd({
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "关于51黑料网",
    "description": "51黑料网成立于2023年，致力于打造中国最具真实性和深度的娱乐八卦与黑料爆料聚合平台。汇聚全网一手资讯，用严谨的态度还原每一个事件的真相。",
    "url": "http://bxubjgt.cn/about",
    "mainEntity": {
      "@type": "Organization",
      "name": "51黑料网",
      "foundingDate": "2023",
      "description": "做最有态度的娱乐爆料平台",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "400-888-9999",
        "contactType": "爆料投稿",
        "email": "tips@bxubjgt.cn"
      }
    }
  });

  // Schema.org BreadcrumbList
  useJsonLd({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "首页",
        "item": "http://bxubjgt.cn/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "关于我们",
        "item": "http://bxubjgt.cn/about"
      }
    ]
  });

  return (
    <>
      <Navbar />

      <main>
        {/* Brand Story Section */}
        <section className="pt-24 md:pt-28 px-4 md:px-6" aria-labelledby="brand-heading">
          <div className="max-w-5xl mx-auto">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-50 text-primary-600 text-xs font-medium whitespace-nowrap">
              关于 51 黑料网
            </span>
            <div className="mt-6 flex flex-col lg:flex-row gap-10 lg:gap-0">
              <div className="lg:w-2/5"></div>
              <div className="lg:w-3/5">
                <h1
                  id="brand-heading"
                  className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight"
                >
                  做最有态度的<br />娱乐爆料平台
                </h1>
                <p className="mt-6 text-base md:text-lg text-foreground-500 leading-relaxed max-w-xl">
                  51黑料网成立于2023年，致力于打造中国最具真实性和深度的娱乐八卦与黑料爆料聚合平台。
                  我们汇聚全网一手资讯，用严谨的态度还原每一个事件的真相，让吃瓜不再只是消遣，而是了解娱乐行业生态的窗口。
                </p>
                <p className="mt-4 text-base md:text-lg text-foreground-500 leading-relaxed max-w-xl">
                  我们的编辑团队由资深媒体人和娱乐圈内部人士组成，坚持"不造谣、不传谣、用事实说话"的原则，
                  为每一位关注娱乐圈动态的用户提供真实可靠的深度内容。
                </p>
              </div>
            </div>

            {/* Dual Images */}
            <div className="mt-12 flex gap-4 md:gap-5">
              <div className="w-2/5 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20media%20newsroom%20with%20warm%20ambient%20lighting%2C%20editorial%20workspace%20aesthetic%2C%20minimalist%20design%2C%20clean%20composition%2C%20professional%20creative%20atmosphere%2C%20natural%20light%2C%20warm%20neutral%20tones%2C%20no%20people&width=600&height=420&seq=about-brand-1&orientation=landscape"
                  alt="51黑料网编辑部"
                  title="51黑料网编辑部 - 专业娱乐爆料团队"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-3/5 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Creative%20team%20collaboration%20in%20modern%20glass%20office%2C%20warm%20lighting%2C%20editorial%20photography%2C%20minimalist%20interior%2C%20professional%20atmosphere%2C%20clean%20aesthetic%2C%20natural%20light%2C%20warm%20neutral%20tones&width=900&height=420&seq=about-brand-2&orientation=landscape"
                  alt="51黑料网团队"
                  title="51黑料网团队 - 资深媒体人"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="mt-16 md:mt-20 px-4 md:px-6" aria-label="数据统计">
          <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <p className="font-heading text-3xl md:text-4xl font-bold text-primary-500">5000+</p>
              <p className="mt-1 text-xs text-foreground-500">独家爆料</p>
            </div>
            <div>
              <p className="font-heading text-3xl md:text-4xl font-bold text-primary-500">200万+</p>
              <p className="mt-1 text-xs text-foreground-500">月活跃用户</p>
            </div>
            <div>
              <p className="font-heading text-3xl md:text-4xl font-bold text-primary-500">98.7%</p>
              <p className="mt-1 text-xs text-foreground-500">爆料准确率</p>
            </div>
            <div>
              <p className="font-heading text-3xl md:text-4xl font-bold text-primary-500">24h</p>
              <p className="mt-1 text-xs text-foreground-500">每日更新</p>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="mt-16 md:mt-20 px-4 md:px-6" aria-labelledby="reviews-heading">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200 text-foreground-600 text-xs font-medium whitespace-nowrap">
                口碑评价
              </span>
              <h2 id="reviews-heading" className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                业界信赖，<br />用户认可的爆料平台
              </h2>
            </div>

            <div className="space-y-6">
              {testimonials.map((t, index) => (
                <section
                  key={t.id}
                  className={`relative rounded-2xl overflow-hidden ${
                    index % 2 === 0 ? "bg-accent-500" : "bg-background-100"
                  }`}
                  aria-label={`评价 ${index + 1}`}
                >
                  <div className="flex flex-col lg:flex-row items-center gap-0 px-6 md:px-10 py-12 md:py-14">
                    <div className={`lg:w-1/3 flex-shrink-0 relative z-10 ${index % 2 === 0 ? "-mt-16 lg:-mt-20" : ""}`}>
                      <div className="w-full max-w-[220px] mx-auto lg:mx-0 rounded-2xl overflow-hidden">
                        <img
                          src={t.image}
                          alt={t.author}
                          className="w-full object-cover object-top"
                        />
                      </div>
                    </div>
                    <div className="lg:w-2/3 lg:pl-10 text-center lg:text-left mt-6 lg:mt-0">
                      <span className={`text-6xl md:text-7xl font-serif leading-none block mb-3 ${
                        index % 2 === 0 ? "text-background-50/15" : "text-foreground-200/40"
                      }`}>
                        &ldquo;
                      </span>
                      <p className={`text-lg md:text-xl leading-relaxed ${
                        index % 2 === 0 ? "text-background-50" : "text-foreground-800"
                      }`}>
                        {t.content}
                      </p>
                      <div className="mt-5">
                        <p className={`font-medium text-sm ${
                          index % 2 === 0 ? "text-background-50" : "text-foreground-900"
                        }`}>
                          {t.author}
                        </p>
                        <p className={`text-xs mt-1 ${
                          index % 2 === 0 ? "text-background-50/50" : "text-foreground-500"
                        }`}>
                          {t.role}
                        </p>
                      </div>
                    </div>
                  </div>
                  {index % 2 === 0 && (
                    <div className="absolute -top-6 -left-1 w-14 h-14 text-accent-300/20 hidden md:block">
                      <svg viewBox="0 0 100 100" className="w-full h-full">
                        <path d="M15 85 Q40 25 85 15" fill="none" stroke="currentColor" strokeWidth="2.5" />
                        <path d="M8 92 Q35 30 90 10" fill="none" stroke="currentColor" strokeWidth="1.5" />
                      </svg>
                    </div>
                  )}
                </section>
              ))}
            </div>
          </div>
        </section>

        {/* Contact / CTA */}
        <section className="mt-16 md:mt-20 px-4 md:px-6" id="contact" aria-labelledby="contact-heading">
          <div className="max-w-3xl mx-auto text-center py-14 md:py-20">
            <h2
              id="contact-heading"
              className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight"
            >
              合作联系 /<br />爆料投稿
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-md mx-auto leading-relaxed">
              如果你有独家爆料线索或商务合作需求，<br />欢迎通过以下方式联系我们
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="mailto:tips@bxubjgt.cn"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i> 发送邮件
              </a>
              <span className="text-sm text-foreground-400">或致电 400-888-9999</span>
            </div>

            <div className="mt-10 flex items-center justify-center gap-6">
              <a href="#" className="w-10 h-10 rounded-full bg-foreground-50 flex items-center justify-center text-foreground-600 hover:bg-foreground-100 hover:text-foreground-900 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-foreground-50 flex items-center justify-center text-foreground-600 hover:bg-foreground-100 hover:text-foreground-900 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-foreground-50 flex items-center justify-center text-foreground-600 hover:bg-foreground-100 hover:text-foreground-900 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-foreground-50 flex items-center justify-center text-foreground-600 hover:bg-foreground-100 hover:text-foreground-900 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
